import React from 'react';
import { Box, Button } from '@heycater/design-system';
import { ToggleSwitch } from './ToggleSwitch';
import { Backdrop, StyledCookieBar, CookieBarWrapper, CookieBarContent, CookieBarActions, CookieBarDrawer, CookieBarButtonGrey, CookieBarTitle, CookieBarBody, } from './styles';
var en = require('./locales/en/translation');
var de = require('./locales/de/translation');
export var GDPR_COOKIE_CONSENT_NAME = '_heycater_gdpr_optional_cookie_consent';
function checkForCookie() {
    return document.cookie.split(';').some(function (item) {
        return item.trim().indexOf(GDPR_COOKIE_CONSENT_NAME) == 0;
    });
}
function getCookieValue() {
    return document.cookie.includes("".concat(GDPR_COOKIE_CONSENT_NAME, "=true"));
}
function CookieBar(_a) {
    var _b = _a.locale, locale = _b === void 0 ? 'de' : _b, _c = _a.onConsentGiven, onConsentGiven = _c === void 0 ? function () { } : _c, _d = _a.onConsentWithdrawn, onConsentWithdrawn = _d === void 0 ? function () { } : _d, _e = _a.detailsOpen, detailsOpen = _e === void 0 ? false : _e, _f = _a.setDetailsOpen, setDetailsOpen = _f === void 0 ? function () { } : _f, _g = _a.backdrop, backdrop = _g === void 0 ? false : _g;
    var _h = React.useState(checkForCookie()), hasCookie = _h[0], setHasCookie = _h[1];
    var _j = React.useState(hasCookie ? getCookieValue() : false), hasConsented = _j[0], setHasConsented = _j[1];
    var _k = React.useState(hasCookie ? getCookieValue() : true), checked = _k[0], setChecked = _k[1];
    var _l = React.useState(detailsOpen), drawerOpen = _l[0], setDrawerOpen = _l[1];
    var setCookie = function () {
        var ttl = new Date(Date.now() + 90 * 24 * 3600 * 1000);
        var hostname = '.' + window.location.hostname.split('.').slice(-2).join('.');
        setHasCookie(true);
        setDetailsOpen(false);
        if (checked && checked !== hasConsented) {
            onConsentGiven();
            setHasConsented(checked);
        }
        if (!checked && checked !== hasConsented) {
            onConsentWithdrawn();
            setHasConsented(checked);
        }
        document.cookie = "".concat(GDPR_COOKIE_CONSENT_NAME, "=").concat(checked, ";expires=").concat(ttl.toUTCString(), ";path=/;domain=").concat(hostname);
    };
    var t = function (str) {
        return str
            .split('.')
            .reduce(function (o, i) { return o[i]; }, locale === 'en' ? en : de);
    };
    // using `any` here because it's a mixed JSON that cannot be typed here.
    var toggleDrawer = React.useCallback(function () { return setDrawerOpen(!drawerOpen); }, [
        drawerOpen,
    ]);
    React.useEffect(function () {
        if (hasCookie && hasConsented) {
            onConsentGiven();
        }
    }, []);
    return !hasCookie || detailsOpen ? (React.createElement(React.Fragment, null,
        backdrop && React.createElement(Backdrop, null),
        React.createElement(StyledCookieBar, null,
            React.createElement(CookieBarWrapper, null,
                React.createElement(CookieBarContent, null,
                    React.createElement(CookieBarTitle, null, t('consent.question')),
                    React.createElement(CookieBarBody, null, t('consent.description'))),
                React.createElement(CookieBarActions, null, drawerOpen || detailsOpen ? (React.createElement(React.Fragment, null,
                    React.createElement(Button, { size: "lg", rounded: true, onClick: setCookie }, t('options.saveOptions')))) : (React.createElement(React.Fragment, null,
                    React.createElement(CookieBarButtonGrey, { size: "lg", onClick: toggleDrawer }, t('consent.configure')),
                    React.createElement(Button, { size: "lg", rounded: true, onClick: setCookie }, t('consent.okay')))))),
            drawerOpen || detailsOpen ? (React.createElement(CookieBarDrawer, null,
                React.createElement(Box, null,
                    React.createElement(CookieBarTitle, null,
                        t('options.essential.title'),
                        t('options.essential.parens')),
                    React.createElement(CookieBarBody, null,
                        React.createElement("p", null, t('options.essential.description')))),
                React.createElement(Box, null,
                    React.createElement(Box, { display: "flex", alignItems: "center" },
                        React.createElement(CookieBarTitle, null, t('options.analytics.title')),
                        React.createElement(Box, { ml: 2 },
                            React.createElement(ToggleSwitch, { id: "accepts_analytics", checked: checked, onChange: function () { return setChecked(!checked); } }))),
                    React.createElement(CookieBarBody, null, t('options.analytics.description'))))) : null))) : null;
}
export default CookieBar;
